import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';
import { OAuthTokenResponse, StoredAuthTokens } from '../interfaces/oauth';

export const b04AuthEvents = eventGroup({
  source: 'B04Auth',
  events: {
    // --- Standard OAuth (Authorization Code + PKCE) flow ---
    initiateOAuthFlow: type<void>(),
    /** Emitted instead of `initiateOAuthFlow` in 'on-demand' login mode when no token is available. */
    loginRequired: type<void>(),
    exchangeTokensForCode: type<{ code: string; state: string }>(),
    exchangeTokensForCodeSuccess: type<{ response: OAuthTokenResponse }>(),
    exchangeTokensForCodeFailure: type<void>(),
    refreshToken: type<void>(),
    refreshTokenSuccess: type<{ response: OAuthTokenResponse }>(),
    refreshTokenFailure: type<void>(),
    scheduleTokenRefresh: type<void>(),
    loadTokensFromStorage: type<void>(),
    loadTokensFromStorageSuccess: type<{ tokens: StoredAuthTokens }>(),
    loadTokensFromStorageFailure: type<void>(),

    // --- Embedded (iframe) flow ---
    requestTokensFromParent: type<void>(),
    requestTokensFromParentSuccess: type<{ tokens: StoredAuthTokens }>(),
    requestTokensFromParentFailure: type<void>(),
  },
});
